export default __webpack_public_path__ + "img/a7b0d46d3b7d79966f5016f26454aa0d.svg";